module.exports = __webpack_public_path__ + "static/media/rocket.31510dcf.svg";